export default __webpack_public_path__ + "static/media/bill.7751b66a.svg";